export enum ProjectType {
    ProjectionCost = 1,
    Rational = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/ProjectType.ts